import { Box, Flex, Heading4 } from "@nulogy/components";
import React from "react";

export default function Section({ title, controls, children, ...boxProps }) {
  const titleProps = controls ? { marginBottom: 0 } : {};

  return (
    <Box marginBottom="x5" {...boxProps}>
      <Flex alignItems="center" justifyContent="space-between">
        {title && (
          <Heading4 color="midGrey" fontWeight="medium" {...titleProps}>
            {title}
          </Heading4>
        )}
        {controls && <Box>{controls}</Box>}
      </Flex>
      {children}
    </Box>
  );
}
